<template>
<el-dialog title="" v-model="visible" custom-class="share-modal bind-screen" :show-close="true" @close="bindClose">
  <div class="code-img">
    <div class="bind-left">
      <div class="bind-title">打开新的微信号&nbsp;&nbsp;扫描右方二维码</div>
      <div class="bind-row">
        <div class="bind-col">
          <img class="bind-aimg" src="../../../../assets/imgs/ba1.png" width="70">
          <div class="bind-atxt">用微信小程序线下接单</div>
        </div>
        <div class="bind-col">
          <img class="bind-aimg" src="../../../../assets/imgs/ba2.png" width="70">
          <div class="bind-atxt">一键分享商品给顾客</div>
        </div>
      </div>
      <div class="bind-row">
        <div class="bind-col">
          <img class="bind-aimg" src="../../../../assets/imgs/ba3.png" width="70">
          <div class="bind-atxt">顾客下单传资料进度随时查</div>
        </div>
        <div class="bind-col">
          <img class="bind-aimg" src="../../../../assets/imgs/ba4.png" width="70">
          <div class="bind-atxt">签证状态微信同步推送</div>
        </div>
      </div>
    </div>
    <div class="bind-right">
      <div class="bind-code-wrap">
        <img :src="reBindQrcode" class="bind-code">
      </div>
      <div class="bind-steps">
        <p style="padding-left:16px"><span>1</span>打开微信扫一扫</p>
        <p style="padding-left:16px"><span>2</span>点击”允许“申请操作</p>
        <p style="padding-left:16px"><span>3</span>完成绑定</p>
      </div>
    </div>
  </div>
</el-dialog>
</template>

<script>
import WxUtils from '../../../../libs/wx-utils';
import User from '../../../../libs/user';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      reBindQrcode: '',
    };
  },
  watch: {
    visible(newValue) {
      this.$emit('update:show', newValue);
    },
    show(val) {
      this.visible = val;
      if (val) {
        this.initQrcode();
      }
    },
  },
  created() {
  },
  methods: {
    bindClose() {
      this.visible = false;
    },
    initQrcode() {
      WxUtils.getBindPageQRCode(User.peer_account_id, true).then((url) => {
        this.reBindQrcode = url;
      });
    },
  },
};
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/components/rebind-wx-dialog.vue